module.exports = __webpack_public_path__ + "static/media/Intersection 27.32384835.png";